module.exports = __webpack_public_path__ + "static/media/school.cd8aa3ff.png";